import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { RestQueryHookResult } from 'utils/hooks/api/useRestQuery';
import { selectFeatureFlags } from 'core/userContext';

import { useLegacyEndpoint } from './useLegacyEndpoint';
import { useNewEndpoint } from './useNewEndpoint';
import { HookData } from './types';

export const useUserProfileContactProperties = (): Omit<RestQueryHookResult, 'data'> & {
  data: HookData;
} => {
  const { DeprecateGetFieldMappingsEndpointInUI } = useSelector(selectFeatureFlags);

  // Memoize initial FF value -- can't switch hooks after mount, otherwise react throws errors
  const isNewEndpointEnabled = useMemo(() => DeprecateGetFieldMappingsEndpointInUI, []);

  return isNewEndpointEnabled ? useNewEndpoint() : useLegacyEndpoint();
};
